import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import './Loading.css'

class Loading extends Component {
	constructor(props) {
		super(props);
		this.state = {
			line1: 'Loading . . .',
			textAnimationLine1: [],
			Loading: false,
			countDownLoading: 0
		}
	}

	componentDidMount() {
		let mArr = []
		for (var i = 0; i < 20; i++) {
			mArr[i] = { letterAni: 0 }
		}
		this.setState({
			textAnimationLine1: mArr
		})
		setInterval(() => {
			if (this.state.countDownLoading <= 13 && !this.state.Loading) {
				mArr[this.state.countDownLoading] = { letterAni: 1 }
				this.setState({
					textAnimationLine1: mArr,
					countDownLoading: this.state.countDownLoading + 1
				})
			} else {
				this.setState({
					Loading: true
				})
				mArr[this.state.countDownLoading] = { letterAni: 0 }
				this.setState({
					textAnimationLine1: mArr,
					countDownLoading: this.state.countDownLoading - 1
				})
				if (this.state.countDownLoading === 0) {
					mArr[0] = { letterAni: 0 }
					this.setState({
						textAnimationLine1: mArr,
					})
					if (this.props.StoreReducer.HomePage.SelectedPage === 0) {
						let ZeroValues = {
							Loading: false
						}
						this.setState({
							Loading: false,
							countDownLoading: 20
						})
						this.props.LoadingPage('ZeroValues', ZeroValues)
					} else if (this.props.StoreReducer.HomePage.SelectedPage === 1 && this.state.Loading) {
						let AboutPage = {
							Loading: true
						}
						this.setState({
							Loading: false,
							countDownLoading: 20
						})
						this.props.LoadingPage('AboutPageLoading', AboutPage)
					}
					else if (this.props.StoreReducer.HomePage.SelectedPage === 2 && this.state.Loading) {
						let SkillPage = {
							Loading: true
						}
						this.setState({
							Loading: false,
							countDownLoading: 20
						})
						this.props.LoadingPage('SkillPageLoading', SkillPage)
					}
					else if (this.props.StoreReducer.HomePage.SelectedPage === 3 && this.state.Loading) {
						let MyWorkPage = {
							Loading: true
						}
						this.setState({
							Loading: false,
							countDownLoading: 20
						})
						this.props.LoadingPage('MyWorkPageLoading', MyWorkPage)
					}
					else if (this.props.StoreReducer.HomePage.SelectedPage === 4 && this.state.Loading) {
						let ContactPage = {
							Loading: true
						}
						this.setState({
							Loading: false,
							countDownLoading: 20
						})
						this.props.LoadingPage('ContactPageLoading', ContactPage)
					}
					this.setState({
						Loading: false,
						countDownLoading: 20
					})
				}
			}
		}, 100)
	}

	render() {
		return (<>
			<div className="LoadingMainDivision">
				<h2 className='Logo-1SelLoading'>S</h2>
				<div className="LoadingDivText">{this.state.line1.split('').map((ite, index) => {
					return (<>
						<span className={this.state.textAnimationLine1[index]?.letterAni === 0 ? 'LetterAniLoadingHidn' : 'LetterAniLoading'}>{ite}</span>
					</>)
				})}</div>
			</div>
		</>);
	}
}

const mapStateToProps = (state) => ({
	StoreReducer: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
	LoadingPage: (type, payload) => dispatch({
		type: type,
		payload: payload
	})
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Loading));